var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPatrimonial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 199,
    viewBox: "0 0 199 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.5 132.667H107.792C113.32 132.667 124.375 129.35 124.375 116.083C124.375 102.817 113.32 99.5 107.792 99.5H91.2083C85.6803 99.5 74.625 96.1833 74.625 82.9167C74.625 69.65 85.6803 66.3333 91.2083 66.3333H99.5M99.5 132.667H74.625M99.5 132.667V149.25M99.5 66.3333H124.375M99.5 66.3333V49.75M174.125 99.5C174.125 140.715 140.715 174.125 99.5 174.125C58.2858 174.125 24.875 140.715 24.875 99.5C24.875 58.2858 58.2858 24.875 99.5 24.875C140.715 24.875 174.125 58.2858 174.125 99.5Z",
    stroke: "white",
    strokeWidth: 12.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPatrimonial);
export default __webpack_public_path__ + "static/media/iconPatrimonial.bb5e43dff1c7cd6a86f66dd528eb253d.svg";
export { ForwardRef as ReactComponent };